<template>
  <div class="complete-order-wrapper d-flex fl-s-b" data-cy="payment-step">
    <div class="booking-left-side d-flex fl-col fl-s-b">
      <div>
        <div
          class="mb-2.5"
          v-for="paymentSetting in paymentSettings"
          :key="paymentSetting.id"
        >
          <SButton
            type="button"
            :id="PaymentMethodTypeToTranslatedString[paymentSetting.id]"
            class="w-full payment-option"
            :class="{
              selected:
                paymentTool ===
                  PaymentMethodTypeToPaymentTool[paymentSetting.id] &&
                step === BookingStep.Payment &&
                !isFree1,
              'disabled-payment-option':
                disablePaymentTool(
                  PaymentMethodTypeToPaymentTool[paymentSetting.id]
                ) ||
                step === BookingStep.Refund ||
                promocodeBeingChecked,
            }"
            :disabled="
              disablePaymentTool(
                PaymentMethodTypeToPaymentTool[paymentSetting.id]
              ) ||
              isFree1 ||
              isFullyPaidInPromocodeStep ||
              isFullyPaidInDiscountStep ||
              step === BookingStep.Refund ||
              promocodeBeingChecked
            "
            data-cy="payment-method"
            @click="
              updatePaymentTool(
                paymentSetting.id,
                PaymentMethodTypeToPaymentTool[paymentSetting.id]
              )
            "
          >
            {{ PaymentMethodTypeToTranslatedString[paymentSetting.id] }}
          </SButton>
        </div>

        <div class="mb-2.5" v-if="showDiscount">
          <SButton
            v-if="showDiscountButton"
            type="button"
            class="w-full payment-option"
            :class="{
              selected: step === BookingStep.Discount,
              'disabled-payment-option':
                disablePaymentTool(PaymentTool.CardManual) ||
                step === BookingStep.Refund ||
                promocodeBeingChecked,
            }"
            :disabled="
              disablePaymentTool(PaymentTool.CardManual) ||
              step === BookingStep.Refund ||
              promocodeBeingChecked
            "
            data-cy="payment-method"
            @click="displayDiscounts"
          >
            {{ $t("button.discount") }}
          </SButton>
        </div>
        <div class="mb-2.5" v-if="step !== BookingStep.Refund">
          <SButton
            type="button"
            class="w-full payment-option"
            :class="{
              selected: step === BookingStep.Promocode,
            }"
            data-cy="payment-method"
            @click="displayPromocodeArea"
          >
            Promocode
          </SButton>
        </div>

        <div class="mb-2.5" v-if="step !== BookingStep.Refund">
          <SButton
            type="button"
            class="w-full payment-option"
            :class="{
              selected: step === BookingStep.PromocodeCampaigns,
            }"
            data-cy="payment-method"
            @click="displayPromocodeCampaigns"
          >
            {{ $t("button.promocode-campaigns") }}
          </SButton>
        </div>

        <div class="mb-2.5" v-if="step !== BookingStep.Refund">
          <SButton
            type="button"
            class="w-full payment-option"
            :class="{
              selected: step === BookingStep.Offers,
              'disabled-payment-option': promocodeBeingChecked,
            }"
            :disabled="promocodeBeingChecked"
            data-cy="payment-method"
            @click="displayOffers"
          >
            {{ $t("offers.offers") }}
          </SButton>
        </div>

        <div class="mb-2.5" v-if="step === BookingStep.Refund">
          <SButton
            type="button"
            variant="destructive"
            class="w-full payment-option selected-warning"
            data-cy="refund-button"
          >
            {{ $t("button.refund") }}
          </SButton>
        </div>
      </div>
    </div>

    <div class="booking-right-side d-flex fl-col">
      <div v-if="step === BookingStep.Refund" class="d-flex fl-col fl-j-c">
        <div class="d-flex flex-row fl-j-c">
          <SButton
            type="button"
            variant="outline"
            class="order-amount default-cursor"
            data-cy="refund-amount"
          >
            {{ refundAmountText }}
          </SButton>
        </div>
        <div class="d-flex flex-row fl-j-c">
          <SSelect v-model="refundPaymentMethod">
            <SSelectTrigger class="w-[220px]" data-cy="refund-method-select">
              <SSelectValue />
            </SSelectTrigger>
            <SSelectContent>
              <SSelectItem
                data-cy="refund-option"
                class="refund-option"
                v-for="paymentSetting in refundPaymentMethodOptions"
                :key="paymentSetting.id"
                :value="paymentSetting.id"
                :disabled="isRefundPaymentMethodDisabled(paymentSetting)"
              >
                {{ PaymentMethodTypeToTranslatedString[paymentSetting.id] }}
              </SSelectItem>
            </SSelectContent>
          </SSelect>
        </div>
        <div class="d-flex flex-row fl-j-c">
          <SButton
            type="button"
            size="lg"
            class="apply-btn"
            data-cy="apply-refund-button"
            @click="handleRefund(refundAmount)"
          >
            {{ $t("promocode.apply") }}
          </SButton>
        </div>
      </div>
      <div
        v-else-if="
          step !== BookingStep.Discount &&
          step !== BookingStep.Promocode &&
          step !== BookingStep.PromocodeCampaigns &&
          step !== BookingStep.Offers &&
          !isFree1
        "
      >
        <div
          v-if="paymentTool === PaymentTool.Cash"
          style="display: flex; flex-direction: column; align-items: center"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
              height: 70px;
              width: 50%;
            "
          >
            <div>
              <p style="font-size: 1.125rem">
                {{ $t("multicurrencies.cash-payment") }}
              </p>
            </div>
            <div>
              <SButton
                v-if="currencies.length > 1 && hasMultiCurrenciesEnabled"
                type="button"
                variant="link"
                class="h-auto p-0 font-bold"
                data-cy="pay-in-other-currencies-toggle"
                @click="toggleMultiCurrencies"
              >
                {{
                  payInMultiCurrencies
                    ? `${$t(
                        "multicurrencies.pay-in"
                      )} ${bookingPaymentCurrency}`
                    : $t("multicurrencies.pay-in-other-currencies")
                }}
              </SButton>
            </div>
          </div>
          <SSeparator
            style="width: 50%; border: 1px solid rgba(0, 0, 0, 0.15)"
          />
          <div
            v-if="payInMultiCurrencies"
            style="
              width: 50%;
              height: 150px;
              display: flex;
              flex-direction: column;
              align-items: start;
              justify-content: end;
              gap: 1rem;
            "
          >
            <div>
              <p class="light-text">
                {{ $t("multicurrencies.currency-of-payment") }}
              </p>
            </div>
            <div style="display: flex; justify-content: center; width: 100%">
              <div class="flex gap-2">
                <SButton
                  v-for="currency in currencies.filter(
                    (c: Currency) => c.label !== bookingPaymentCurrency
                  )"
                  :key="currency.id"
                  type="button"
                  size="lg"
                  :variant="
                    selectedCashCurrencyLabel === currency.label
                      ? 'default'
                      : 'outline'
                  "
                  @click="selectedCashCurrencyChanged(currency.label)"
                >
                  {{ currency.label }}
                </SButton>
              </div>
            </div>
            <div
              :style="{
                visibility: selectedCashCurrency ? 'visible' : 'hidden',
              }"
              style="
                display: flex;
                justify-content: space-between;
                align-items: end;
                width: 100%;
                height: 50px;
              "
            >
              <div>
                <p class="light-text">
                  1 {{ groupCurrency.label }} =
                  {{ selectedCashCurrency?.exchangeRate }}
                  {{ selectedCashCurrency?.label }}
                </p>
              </div>
              <div>
                <p class="light-text">
                  {{ displayedAmount }}
                </p>
              </div>
            </div>
          </div>
          <el-row style="width: 100%" justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="['order-amount', whatIsLeftToPay ? '' : 'default-cursor']"
              @click="whatIsLeftToPay ? showCalculator() : null"
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
          <el-row>
            <SButton
              type="button"
              variant="outline"
              class="amount-button"
              data-cy="partial-pay-custom"
              @click="showCalculator"
            >
              {{ $t("button.custom") }}
            </SButton>
            <SButton
              type="button"
              variant="outline"
              class="amount-button"
              data-cy="partial-pay-full"
              @click="updateEnteredAmount(whatIsLeftToPay / 100)"
            >
              {{ whatIsLeftToPayText }}
            </SButton>
            <SButton
              type="button"
              variant="outline"
              class="amount-button"
              data-cy="partial-pay-10"
              @click="updateEnteredAmount(10)"
            >
              {{ (selectedCashCurrency?.label || paymentCurrency) + " " + 10 }}
            </SButton>
          </el-row>
          <el-row>
            <SButton
              type="button"
              variant="outline"
              class="amount-button"
              data-cy="partial-pay-20"
              @click="updateEnteredAmount(20)"
            >
              {{ (selectedCashCurrency?.label || paymentCurrency) + " " + 20 }}
            </SButton>
            <SButton
              type="button"
              variant="outline"
              class="amount-button"
              data-cy="partial-pay-50"
              @click="updateEnteredAmount(50)"
            >
              {{ (selectedCashCurrency?.label || paymentCurrency) + " " + 50 }}
            </SButton>
            <SButton
              type="button"
              variant="outline"
              class="amount-button"
              data-cy="partial-pay-100"
              @click="updateEnteredAmount(100)"
            >
              {{ (selectedCashCurrency?.label || paymentCurrency) + " " + 100 }}
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.CardAuto">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              data-cy="partial-pay-custom"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.BankTransfer">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.Invoice">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.ToBeInvoiced">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.CardManual">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              data-cy="partial-pay-custom"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.Cheque">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.ChequeVacances">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.ChequeCulture">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.PassCulture">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.Chorus">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.CE">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.OCCYG">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.CouponSport">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.PosReka">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>

        <div v-else-if="paymentTool === PaymentTool.BuyClub">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>

        <div v-else-if="paymentTool === PaymentTool.POS_BIMPLI_CADO">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>

        <div v-else-if="paymentTool === PaymentTool.POS_KADEOS_INFINI">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>

        <div v-else-if="paymentTool === PaymentTool.POS_ANCV_CONNECT">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>

        <div v-else-if="paymentTool === PaymentTool.DiverseVoucher">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.CFF">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.CGN">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.QOQA">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.DEINDEAL">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <div v-else-if="paymentTool === PaymentTool.REALDEAL">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>

        <div v-else-if="paymentTool === PaymentTool.TOUT_UN_CANTON">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>

        <div v-else-if="paymentTool === PaymentTool.CHAPLINS">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>
        <!-- //// -->
        <div v-else-if="paymentTool === PaymentTool.EXTERNAL_INCERT_VOUCHER">
          <IncertVoucher />
        </div>
        <!-- //// -->

        <div
          v-else-if="paymentTool === PaymentTool.Swiss_QR_Code_Bank_Transfer"
        >
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
            >
              {{ displayedAmount }}
            </SButton>
          </el-row>
        </div>

        <div v-else-if="paymentTool === PaymentTool.HELLO_CSE">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>

        <div v-else-if="paymentTool === PaymentTool.Z_CH_GUTSCHEIN">
          <el-row justify="center">
            <SButton
              type="button"
              variant="outline"
              :class="[
                'order-amount',
                whatIsLeftToPay && doesSupportSplitPayment
                  ? ''
                  : 'default-cursor',
              ]"
              @click="
                whatIsLeftToPay && doesSupportSplitPayment
                  ? showCalculator()
                  : null
              "
            >
              {{ displayedAmount }}
              <SvgIcon
                v-if="whatIsLeftToPay && doesSupportSplitPayment"
                :iconContent="iconContent"
                :iconAlt="iconAlt"
                :iconStyle="iconStyle"
              />
            </SButton>
          </el-row>
        </div>

        <div v-else>
          <el-row justify="center">
            <p>
              {{ $t("payment.no-payment-method") }}
            </p>
          </el-row>
        </div>
      </div>
      <div v-else-if="step === BookingStep.Promocode">
        <Promocode />
      </div>
      <div v-else-if="step === BookingStep.Discount">
        <Discount />
      </div>
      <PromocodeCampaigns v-else-if="step === BookingStep.PromocodeCampaigns" />
      <Offers v-else-if="step === BookingStep.Offers" />
    </div>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, watch, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import BookingModule from "@/store/modules/booking";
import { Currencies, Currency } from "@/constants/currency";
import {
  deleteUncompletedBookingAccountings,
  applyPayment,
  createRefundPSSAccounting,
} from "@/utils/vue-helpers/accounting";
import { SvgIcon } from "@/components/index";
import editPenSvg from "@/assets/images/svg/edit-pen.svg";
import {
  SButton,
  SSeparator,
  SSelect,
  SSelectTrigger,
  SSelectValue,
  SSelectContent,
  SSelectItem,
} from "@smeetz/ui-core";

import {
  AccountingState,
  IAccounting,
  PaymentCard,
  PaymentMethods,
  PaymentTool,
  TransactionTypes,
} from "@/types/db/accounting";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
import { PSBErrors } from "@/constants/errors/product-slot-booking";
import { DiscountTypes, IBookingsSteps } from "@/interfaces/store/IBooking";
import { IBookingPayment } from "@/interfaces/store/IBooking";
import { BookingStep } from "@/constants/booking";
import {
  IPaymentConfig,
  PaymentMethodTypeToPaymentTool,
  PaymentMethodTypes,
} from "@/types/db/pos-config";
import POSConfigModule from "@/store/modules/pos-config";
import {
  canCompleteOrder,
  toLocalAccountings,
  updateEnteredAmount,
} from "@/utils/vue-helpers/booking";
import Discount from "./Discount.vue";
import Promocode from "./Promocode.vue";
import IncertVoucher from "./IncertVoucher.vue";
import { syncAvailabilities } from "@/db/product-slot-booking";
import { formatCurrency } from "@/utils/helpers/currency";
import i18n, { getLocale } from "@/lang";
import { cloneDeep } from "lodash";
import { LogService } from "@/services/logging";
import {
  getDefaultPaymentTool,
  PaymentMethodTypeToTranslatedString,
} from "@/utils/vue-helpers/pos-config";
import dayjs from "dayjs";
import { BookingStatus, RefundStatus } from "@/types/db/product-slot-state";
import CashFloatModule from "@/store/modules/cash-float";
import { ref } from "vue";
import { PaymentToolMethod } from "@/types/db/accounting";
import PaymentService from "@/services/payment-service";
import {
  bookingTotalIgnoringDiscounts,
  discountTotal,
  isBookingFree,
  restToPay,
} from "@/utils/vue-helpers/new-accountings";
import { hasMultiCurrenciesEnabled } from "@/utils/vue-helpers/cash-float";
import { roundToNearestMultipleOf5, sumArray } from "@/utils/helpers/common";
import { getPSSValue } from "@/utils/helpers/product-slot-state";
import PromocodeCampaigns from "./PromocodeCampaigns.vue";
import Offers from "./Offers.vue";
import UserModule from "@/store/modules/user";
import NotificationService from "@/services/notification.service";
import AppModule from "@/store/modules/app";
import {
  getAccountingWithUUID,
  getBookingAccountings,
  getBookingWithUUID,
} from "@/api/gql/product-slot-boooking";
import { postPOSRefund } from "@/api/payment";
import Timeout from "await-timeout";
import { ACCErrors } from "@/constants/errors/accounting";
import {
  isBookingInDexie,
  syncBookingAvailabilities,
} from "@/utils/helpers/booking";
import { adyenPaymentMethods } from "@/constants/payment";
import { startRefundListener } from "@/services/sync-service";
import { ElMessageBox } from "element-plus";

export default defineComponent({
  name: "app",
  components: {
    Discount,
    SvgIcon,
    Promocode,
    PromocodeCampaigns,
    IncertVoucher,
    Offers,
    SButton,
    SSeparator,
    SSelect,
    SSelectTrigger,
    SSelectValue,
    SSelectContent,
    SSelectItem,
  },
  setup() {
    const { t } = useI18n({});
    const iconStyle = "filter: contrast(170%) invert(0%); padding-left: 10px;";
    const iconContent = editPenSvg;
    const iconAlt = "edit";

    const posConfig = POSConfigModule.selectedConfig;

    const isEditOrder = ref(false);

    watchEffect(async () => {
      if (BookingModule.selectedBookingUUID) {
        isEditOrder.value = await isBookingInDexie(
          BookingModule.selectedBookingUUID
        );
      }
    });

    const cashPaymentMethod = computed(() => {
      return POSConfigModule.getPaymentConfig.cash.used;
    });

    const bookingPaymentCurrency = computed(() => {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value]
        .currency;
    });

    const paymentCurrency = computed(() => {
      if (
        paymentTool.value === PaymentTool.Cash &&
        selectedCashCurrency.value
      ) {
        return selectedCashCurrency.value.label;
      }
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value]
        .currency;
    });

    const cardAutoPaymentMethod = computed(() => {
      return POSConfigModule.getPaymentConfig.cardAuto.used;
    });

    const cardManualPaymentMethod = computed(() => {
      return POSConfigModule.getPaymentConfig.cardManual.used;
    });

    const bankTransferPaymentMethod = computed(() => {
      return POSConfigModule.getPaymentConfig.bankTransfer.used;
    });

    const InvoicePaymentMethod = computed(() => {
      return POSConfigModule.getPaymentConfig.invoice.used;
    });

    const ChequePaymentMethod = computed(() => {
      return (
        POSConfigModule.getPaymentConfig.cheque?.used &&
        (POSConfigModule.getGroupCountryCode === "FR" || getLocale() === "fr")
      );
    });

    const ChequeVacancesPaymentMethod = computed(() => {
      return (
        POSConfigModule.getPaymentConfig.chequeVacances?.used &&
        (POSConfigModule.getGroupCountryCode === "FR" || getLocale() === "fr")
      );
    });

    const CEPaymentMethod = computed(() => {
      return (
        POSConfigModule.getPaymentConfig.CE?.used &&
        groupId.value &&
        [19360, 16342, 16342].includes(groupId.value)
      );
    });

    const OCCYGPaymentMethod = computed(() => {
      return (
        POSConfigModule.getPaymentConfig.OCCYG?.used &&
        groupId.value &&
        [19360, 16342, 16342].includes(groupId.value)
      );
    });

    const isFree1 = computed(() => {
      // A booking is considered FREE if their tickets are free or is fully discounted
      return isBookingFree.value;
    });

    const isFullyPaidInPromocodeStep = computed(() => {
      // A booking that becomes fully paid in Promocode Step will have payment methods disabled
      return (
        (BookingModule.bookingStep === BookingStep.Promocode ||
          BookingModule.bookingStep === BookingStep.PromocodeCampaigns) &&
        restToPay.value <= 0
      );
    });

    const isFullyPaidInDiscountStep = computed(() => {
      // A booking that becomes fully paid in Discount Step will have payment methods disabled
      return (
        BookingModule.bookingStep === BookingStep.Discount &&
        restToPay.value <= 0
      );
    });

    const step = computed(() => {
      return BookingModule.bookingStep;
    });

    const showDiscount = computed(() => {
      const hasDiscountRole = !UserModule.isSellerNoDiscount;
      return (
        hasDiscountRole &&
        (POSConfigModule.getPaymentConfig.cash.used ||
          POSConfigModule.getPaymentConfig.cardAuto.used ||
          POSConfigModule.getPaymentConfig.cardManual.used)
      );
    });

    const groupId = computed(() => {
      return POSConfigModule.groupId;
    });
    const groupCurrencies = computed(() => {
      return POSConfigModule.groupCurrencies;
    });

    const currencies = computed(() => {
      const currencies = [];
      const startAmounts = CashFloatModule.cashFloat?.startAmounts;
      for (const currency in startAmounts) {
        const currencyInfo = groupCurrencies.value.find(
          (c) => c.label === currency
        );
        if (currencyInfo) {
          currencies.push(currencyInfo);
        }
      }
      return currencies;
    });

    // for multi currency payments
    const selectedCashCurrency = computed(() => {
      return BookingModule.selectedCashCurrency;
    });

    const selectedCashCurrencyLabel = computed(() => {
      return selectedCashCurrency.value?.label || "";
    });

    const groupCurrency = computed(() => {
      const currency =
        currencies.value.find((c) => c.isDefault === 1) || currencies.value[0];
      return currency.label;
    });

    // if there is no tracking of payments for the currently selected booking then initiate it
    if (
      !BookingModule.bookingsAmountsTrack[
        String(BookingModule.selectedBooking?.uuid)
      ]
    )
      initiateAmountsTracking();

    const paymentSettings = computed(() => {
      // Return only payment settings that are used
      return POSConfigModule.getPaymentSettings.filter((setting: any) => {
        return setting.used;
      });
    });

    const promocodeBeingChecked = computed(() => {
      return BookingModule.promocodeBeingChecked;
    });

    function selectdefaultPaymentMethod() {
      // We only support Cash with Refund, we don't force the user his default payment method in this case
      if (BookingModule.bookingStep !== BookingStep.Refund) {
        const usedPaymentTool = getDefaultPaymentTool();
        updatePaymentTool(usedPaymentTool.id, usedPaymentTool.name);
      }
    }
    function initiateAmountsTracking() {
      const BookingUUID = BookingModule.selectedBooking?.uuid as string;

      let usedPaymentTool = POSConfigModule.getPaymentSettings.filter(
        (paymentMethod: any) => {
          return paymentMethod.used === true;
        }
      )[0];

      const track: IBookingPayment = {
        currentAmount: 0,
        currency: BookingModule.selectedBooking?.currency || Currencies.CHF,
        // paymentTool: PaymentTool.CardAuto,
        paymentTool: usedPaymentTool.name,
        paymentToolId: usedPaymentTool.id || null,
        paymentCard: null,
        // paymentCard: PaymentCard.Mastercard,
        confirmedAmounts: [],
      };
      BookingModule.addPaymentTracking({ BookingUUID, track });
    }

    const selectedBookingUUID = computed(() => {
      let selectedBooking = BookingModule.selectedBooking;
      if (!selectedBooking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }
      const uuid = selectedBooking.uuid as string;
      if (!uuid) {
        throw new Error(PSBErrors.HasNoUUID);
      }
      return uuid;
    });

    const formattedPaymentCurrency = computed(() => {
      return formatCurrency(BookingModule.selectedBooking!.currency);
    });

    const hasEnteredAmount = computed(() => {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value]
        .currentAmount;
    });

    const isFullDiscount = computed(() => {
      if (bookingTotalIgnoringDiscounts.value <= discountTotal.value) {
        return true;
      }
      return false;
    });

    const paymentTool = computed(() => {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value]
        .paymentTool;
    });

    const paymentCard = computed(() => {
      return BookingModule.bookingsAmountsTrack[selectedBookingUUID.value]
        .paymentCard;
    });

    /**
     * The amount we display for the user to pay
     * For bookings that support split payment it is what is left to pay OR it is what the user enters
     * For normal bookings it is the sum of pss final values, if user enters an amount, then we show it
     */
    const displayedAmount = computed(() => {
      // if (paymentTool.value === PaymentTool.Cash) {
      //   return (
      //     formatCurrency(paymentCurrency.value) +
      //     " " +
      //     hasEnteredAmount.value.toFixed(2)
      //   );
      // }
      if (splitAmountToBePaid.value) {
        return splitAmountText.value;
      } else {
        return whatIsLeftToPayText.value;
      }
    });

    const whatIsLeftToPayText = computed(() => {
      return (
        formatCurrency(paymentCurrency.value) +
        " " +
        /*Math.abs*/ (whatIsLeftToPay.value / 100).toFixed(2)
      );
    });

    const whatIsLeftToPay = computed(() => {
      return restToPay.value * (selectedCashCurrency.value?.exchangeRate || 1);
    });

    const splitAmountToBePaid = computed(() => {
      // we take the value before it was rounded (if it was), because thats what the user supplied
      return (
        (BookingModule.splitAmount?.splitAmountProvided || 0) *
        (selectedCashCurrency.value?.exchangeRate || 1)
      );
    });

    const splitAmountText = computed(() => {
      return (
        formatCurrency(paymentCurrency.value) +
        " " +
        splitAmountToBePaid.value.toFixed(2)
      );
    });

    const doesSupportSplitPayment = computed(() => {
      return BookingModule.doesSupportSplitPayment;
    });

    const splitPayments = computed(() => {
      const paidAmounts = BookingModule.selectedBooking?.accountings
        .filter(
          (acc) =>
            acc.transactionType === 1 &&
            (acc.state === AccountingState.Completed ||
              (acc.state === AccountingState.Pending &&
                !acc.id /*making sure it is not coming from backend*/ &&
                (acc.promocode || acc.promoCodeUuid)) ||
              (acc.state === AccountingState.Pending &&
                acc.paymentMethod === PaymentMethods.METHOD_POS_CASH))
        )
        .flat();
      return paidAmounts;
    });

    const payInMultiCurrencies = ref(false);

    function toggleMultiCurrencies() {
      payInMultiCurrencies.value = !payInMultiCurrencies.value;
      if (!payInMultiCurrencies.value) {
        BookingModule.setSelectedCashCurrency(null);
        updateEnteredAmount(Math.abs(restToPay.value) / 100);
      } else {
        const currency = currencies.value.filter(
          (c) => c.label !== bookingPaymentCurrency.value
        )[0];
        BookingModule.setSelectedCashCurrency(currency);
        updateEnteredAmount(
          (Math.abs(restToPay.value) * currency.exchangeRate) / 100
        );
      }
    }

    function selectedCashCurrencyChanged(
      currencyLabel: string | number | boolean
    ) {
      const currency =
        currencies.value.find((c) => c.label === currencyLabel) || null;
      BookingModule.setSelectedCashCurrency(currency);
      updateEnteredAmount(
        (Math.abs(restToPay.value) * (currency?.exchangeRate || 1)) / 100
      );
    }

    function updatePaymentCurrency(currency: Currencies) {
      BookingModule.setPaymentCurrency({
        BookingUUID: BookingModule.selectedBookingUUID,
        currency,
      });
    }

    function updatePaymentTool(
      paymentToolId: string,
      paymentTool: PaymentTool
    ) {
      BookingModule.setPaymentTool({
        BookingUUID: BookingModule.selectedBookingUUID,
        paymentTool,
        paymentToolId,
      });
      // isDiscountsDisplayed.value = false;
      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.Payment,
      });
    }

    function updatePaymentCard(paymentCard: PaymentCard) {
      BookingModule.setPaymentCard({
        BookingUUID: BookingModule.selectedBookingUUID,
        paymentCard,
      });
    }

    function showCalculator() {
      ModalModule.setStatus(ModalStatus.PaymentCalculator);
    }

    function disablePaymentTool(paymentOption: PaymentTool): boolean {
      // A payment too is disabled when:
      // It is not selected && Booking has confirmedAmounts && Discount is not selected
      // return (
      //   paymentTool.value !== paymentOption &&
      //   BookingModule.bookingsAmountsTrack[BookingModule.selectedBookingUUID]
      //     .confirmedAmounts.length > 0 &&
      //   paymentTool.value !== PaymentTool.Discount
      // );

      // @Hamza: I am disabling only when discount is selected
      // Please check if this is ok cause now with split payment, there is
      // no reason to disable payment methods.
      if (paymentOption === PaymentTool.Discount) {
        return (
          BookingModule.bookingsAmountsTrack[BookingModule.selectedBookingUUID]
            .confirmedAmounts.length > 0
        );
      }
      return false;
    }

    function displayDiscounts() {
      // First if there is no discount tracking for this booking lets add a discount tracking to this booking with default values
      const d = BookingModule.selectedBookingDiscountTrack;
      if (d) {
        BookingModule.setBookingStep({
          bookingUUID: BookingModule.selectedBookingUUID,
          step: BookingStep.Discount,
        });
        return;
      }

      let selectedBooking = BookingModule.selectedBooking;
      if (!selectedBooking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }

      BookingModule.addDiscountTracking({
        BookingUUID: BookingModule.selectedBookingUUID,
        track: {
          isApplied: false,
          type: DiscountTypes.Percentage_Discount,
          value: 5,
          isOnAllOrder: true,
          pricesIds: [
            ...new Set(selectedBooking.pssList.map((pss) => pss.priceId)),
          ],
          pssDiscounts: [],
          discountTotalValue: 0, // will be calculated when the discount is applied
        },
      });

      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.Discount,
      });
    }

    function displayPromocodeArea() {
      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.Promocode,
      });
    }

    function displayPromocodeCampaigns() {
      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.PromocodeCampaigns,
      });
    }

    function displayOffers() {
      BookingModule.setBookingStep({
        bookingUUID: BookingModule.selectedBookingUUID,
        step: BookingStep.Offers,
      });
    }

    const selectedBooking = computed(() => {
      const booking = BookingModule.selectedBooking;
      if (!booking) {
        throw new Error(PSBErrors.NoBookingInModule);
      }
      return booking;
    });

    function applyCashPayment() {
      deleteUncompletedBookingAccountings(selectedBooking.value);
      applyPayment();
    }

    const refundPaymentMethodOptions = computed(() => {
      // Return used payment methods
      let refundPaymentMethods = [...paymentSettings.value];
      // If there is no payment method left, then we return cash
      if (!refundPaymentMethods.length) {
        refundPaymentMethods.push({
          id: PaymentMethodTypes.Cash,
          name: PaymentMethodTypeToTranslatedString.value[
            PaymentMethodTypes.Cash
          ],
        });
      } else {
        const cardIndex = refundPaymentMethods.findIndex(
          (pm) => pm.id === PaymentMethodTypes.CardAuto
        );
        if (cardIndex > -1) {
          // Push the Card method to bottom of the list if its disabled
          const element = refundPaymentMethods.splice(cardIndex, 1)[0];
          refundPaymentMethods.push(element);
        }
      }

      // Note that INCERT Voucher now is a payment method
      // The refund of this paymentMethod is done automatically when cancelling the confirmed ticket like below:
      // cancel ticket --> create cancellation accounting & refund accounting --> user confirms booking --> POS communicate to external voucher to refund and then confirm refund accounting
      // So we actually do not need INCERT Voucher as a refund payment method to be shown in the dropdown, lets remove it if it is there
      const incertVoucherMethodIndex = refundPaymentMethods.findIndex(
        (p) => p.id === PaymentMethods.EXTERNAL_INCERT_VOUCHER
      );
      if (incertVoucherMethodIndex > -1) {
        refundPaymentMethods = refundPaymentMethods.filter(
          (p) => p.id !== PaymentMethods.EXTERNAL_INCERT_VOUCHER
        );
      }
      return refundPaymentMethods;
    });

    // let's set the default payment method also for refund
    const refundPaymentMethod = ref<PaymentMethodTypes>(
      refundPaymentMethodOptions.value[0].id || PaymentMethodTypes.Cash
    );

    const pssToRefundList = computed(() => {
      const bookingCopy = cloneDeep(selectedBooking.value);
      // get the pss we're about to refund
      const cancelledPss = bookingCopy.pssList.filter(
        (pss) => pss.bookingStatus === BookingStatus.Canceled
      );
      if (!cancelledPss || !cancelledPss.length) {
        return [];
      }
      // Find the ones we need to refund, they are the one that have positive balance
      const cancelledPssUuidString = cancelledPss
        .map((pss) => pss.uuid)
        .join(" - ");
      const pssToRefundList = BookingModule.pssListBalances
        .filter(
          (pss) =>
            cancelledPssUuidString.includes(String(pss.pssUuid)) &&
            pss.balance > 0
        )
        .map((pss) => pss.pss);
      return pssToRefundList;
    });

    async function proceedAdyenRefund(amountInCents: number) {
      const bookingCopy = cloneDeep(selectedBooking.value);
      // checks if an accounting is already refunded by calculating the differnce between payments and refunds
      function alreadyRefunded(splitReference: string) {
        const refundAndPaymentAccountings = bookingCopy.accountings
          .filter((acc) => {
            return (
              adyenPaymentMethods.includes(acc.paymentMethod) &&
              (acc.transactionType ===
                TransactionTypes.TRANSACTION_TYPE_REFUND ||
                acc.transactionType ===
                  TransactionTypes.TRANSACTION_TYPE_PAYMENT) &&
              acc.state === AccountingState.Completed &&
              acc.splitReference === splitReference
            );
          })
          .map((ac) => ac.accountingEntriesList)
          .flat()
          .map((ae) => ae.value);
        const refundAndPaymentSum = sumArray(refundAndPaymentAccountings);
        return refundAndPaymentSum <= 0;
      }
      let accountingToRefund: IAccounting | undefined;
      // we copy the pss to refund list so we can update it after pulling the booking later
      for (let i = 0; i < pssToRefundList.value.length; i++) {
        const pssToRefund = pssToRefundList.value[i];
        accountingToRefund = bookingCopy.accountings.find((acc) => {
          return (
            adyenPaymentMethods.includes(acc.paymentMethod) &&
            acc.transactionType === TransactionTypes.TRANSACTION_TYPE_PAYMENT &&
            acc.splitReference &&
            acc.state === AccountingState.Completed &&
            !alreadyRefunded(acc.splitReference) &&
            acc.accountingEntriesList.some(
              (ae) => ae.productSlotStateUuid === pssToRefund.uuid
            )
          );
        });
        if (accountingToRefund) {
          // one accounting at a time
          break;
        }
      }

      if (!accountingToRefund) {
        LogService.info(`No adyen payment accounting to refund was found`);
        return;
      }
      let bookingId = bookingCopy.id;
      let accountingToRefundId = accountingToRefund.id;
      if (!bookingId || !accountingToRefundId) {
        // booking and accounting ids are needed to do the refund, if not present, it means we are dealing with a locally edited booking
        // therefore, we need to query them from backend
        try {
          AppModule.updatedIsLoading(true);
          const uid = bookingCopy.uuid;
          const accountingUuid = accountingToRefund.uuid;
          if (!uid) {
            throw new Error(PSBErrors.HasNoUUID);
          }
          if (!accountingUuid) {
            throw new Error(ACCErrors.HasNoUUID);
          }
          let bookingInfo;
          let accountingInfo;
          let retries = 0;
          while ((!bookingInfo || !accountingInfo) && retries < 5) {
            bookingInfo = await getBookingWithUUID(uid);
            accountingInfo = await getAccountingWithUUID(accountingUuid);
            LogService.info(
              `Booking with uuid: ${uid} or accounting with uuid: ${accountingUuid} were not found when refunding by card, retrying in 3000ms`
            );
            retries++;
            await Timeout.set(3000);
          }
          if (!bookingInfo || !accountingInfo) {
            // synching failed
            LogService.info(
              `Booking with uuid: ${uid} or accounting with uuid: ${accountingUuid} were not found when refunding by card, stopped retrying`
            );
            NotificationService.showGeneralResponseError();
            return;
          }
          bookingId = bookingInfo.id || undefined;
          accountingToRefundId = accountingInfo.id || undefined;
        } catch (error) {
          LogService.info(
            `Error occured when fetching booking/accounting info: ${selectedBooking.value.uuid}`,
            { error }
          );
          NotificationService.showGeneralResponseError();
        } finally {
          AppModule.updatedIsLoading(false);
        }
      }

      const refundableAmountValues = accountingToRefund.accountingEntriesList
        .filter((ae) =>
          pssToRefundList.value
            .map((pss) => pss.uuid)
            .includes(ae.productSlotStateUuid)
        )
        .flatMap((ae) => ae.value);

      const refundableAmount = sumArray(refundableAmountValues) * -1;

      // we use the smallest amount between the actual accounting value to avoid over-refunding in case of split payments/refunds
      // using Math.max because both values are negative
      const amount = Math.max(amountInCents, refundableAmount);

      const refundData = {
        bookingId: bookingId,
        amount: (amount / 100) * -1, // adyen doesn't take values in cents, and it must be positive
        paymentMethod: accountingToRefund.paymentMethod,
        accounting: accountingToRefundId,
        channel: "SMEETZ POS",
      };
      LogService.info(
        `starting refund with Adyen: ${
          selectedBooking.value.uuid
        } with amount ${amountInCents / 100}, payload attached`,
        { refundData }
      );
      AppModule.updatedIsLoading(true);
      try {
        const refundResponse = await postPOSRefund(refundData);
        // check response validity
        if (
          !refundResponse.data?.productSlotStates ||
          !refundResponse.data?.bookingRecap?.accounting
        ) {
          LogService.info(
            `Unexpected response received when refunding with Adyen: ${
              selectedBooking.value.uuid
            } with amount ${amountInCents / 100}`,
            { refundData, response: refundResponse }
          );
          throw new Error("Unexpected adyen refund response");
        }
        LogService.info(
          `Accounting successfully refunded with adyen with amount ${
            amountInCents / 100
          }, going to update booking`,
          { refundData, response: refundResponse }
        );
        // get the newly created accountings from backend
        const pulledAccountings = await getBookingAccountings(
          String(bookingId)
        );
        if (!pulledAccountings) {
          LogService.info(
            `No accountings were pulled from backend for booking with uuid: ${bookingCopy.uuid}`
          );
          NotificationService.showGeneralResponseError();
          return;
        }
        const remoteAccountings = toLocalAccountings(
          bookingCopy.uuid,
          pulledAccountings
        );

        // get refund accounting created by backend
        const newAdyenAccounting = remoteAccountings.find(
          (remoteAcc) =>
            adyenPaymentMethods.includes(remoteAcc.paymentMethod) &&
            remoteAcc.transactionType ===
              TransactionTypes.TRANSACTION_TYPE_REFUND &&
            !bookingCopy.accountings.some(
              (localAcc) => localAcc.uuid === remoteAcc.uuid
            )
        );

        if (!newAdyenAccounting) {
          // in case refund accounting hasn't been created
          throw new Error("No adyen accounting was created by backend");
        }

        // add the new refund accounting and update the current booking
        const newAccountings =
          bookingCopy.accountings.concat(newAdyenAccounting);

        BookingModule.updateBookingAccountings({
          bookingUUID: bookingCopy.uuid || "",
          accountings: newAccountings,
        });
        if (newAdyenAccounting.state === AccountingState.Failed) {
          const message = newAdyenAccounting.message;
          const keyword = "FAILED_REFUND >>";
          const parts = message?.split(keyword) || [];

          // Check if the keyword exists and there is content after it
          if (parts.length > 1) {
            NotificationService.showCustomMessage(parts[1].trim(), "warning");
          } else {
            // Default message if the keyword is not present
            NotificationService.showCustomMessage(
              String(t("payment-service.unknown")),
              "warning"
            );
          }
        } else if (newAdyenAccounting.state === AccountingState.Started) {
          NotificationService.showCustomInfoWithTitle(
            t("adyen-refund.in-progress-message"),
            t("adyen-refund.in-progress")
          );
          if (bookingCopy.uuid && newAdyenAccounting.uuid) {
            startRefundListener(bookingCopy.uuid, newAdyenAccounting.uuid);
          }
        }
      } catch (error) {
        LogService.info(
          `Error occured when refunding with Adyen: ${
            selectedBooking.value.uuid
          } with amount ${amountInCents / 100}`,
          { refundData, error }
        );
        NotificationService.showGeneralResponseError();
      } finally {
        AppModule.updatedIsLoading(false);
      }
    }

    /**
     * Create Refund accountings for the cancelled PSS with the parameter amount
     * amountInCents is negative
     */
    function proceedRegularRefund(amountInCents: number) {
      const bookingCopy = cloneDeep(selectedBooking.value);
      const refundPaymentTool =
        PaymentMethodTypeToPaymentTool[refundPaymentMethod.value];
      // create TICKET accounting
      let ticketTypeAccounting = createRefundPSSAccounting(
        amountInCents,
        PaymentToolMethod[refundPaymentTool]
      );
      ticketTypeAccounting.forEach((acc: any) =>
        bookingCopy.accountings.push(acc)
      );
      // lests add refund info to the pss
      const pssUuidsList = ticketTypeAccounting
        .map((acc: any) => acc.accountingEntriesList)
        .flat()
        .map((ae: any) => ae.productSlotStateUuid);
      const refundedPssList = bookingCopy.pssList.filter((pss) =>
        pssUuidsList.includes(pss.uuid)
      );
      for (let i = 0; i < refundedPssList.length; i++) {
        refundedPssList[i].refundedAt = dayjs().toISOString();
        refundedPssList[i].refundAmount = getPSSValue(refundedPssList[i]); // because we fully refund a pss
        refundedPssList[i].refundStatus = RefundStatus.Completed;
      }
      //update cashfloat: extract refund amount from total cashfloat
      // const previousCashFloatAmount = CashFloatModule.cashFloat?.amount || 0;
      // const dateNow = dayjs().toISOString();
      // const updatedAmount = previousCashFloatAmount - Math.abs(amountInCents);

      // //update amount field of Cash float in db and state
      // CashFloatModule.setCashFloat(
      //   Object.assign({}, CashFloatModule.cashFloat, {
      //     updatedAt: dateNow,
      //     amount: updatedAmount,
      //   })
      // );

      BookingModule.updateBooking(bookingCopy);
    }

    /**
     * Call appropriate refund function depending on payment method
     * amountInCents is negative
     */
    async function handleRefund(amountInCents: number) {
      if (!selectedBooking.value.uuid) {
        return;
      }
      if (BookingModule.refundListeners[selectedBooking.value.uuid]) {
        LogService.info("Booking already has a refund in progress, aborting");
        NotificationService.showCustomMessageWithTitle(
          t("adyen-refund.already-in-progress-message"),
          t("adyen-refund.in-progress"),
          "warning"
        );
        return;
      }
      LogService.info(
        `Proceeding refund for booking: ${
          selectedBooking.value.uuid
        } with amount ${amountInCents / 100} paymentMethod: ${
          refundPaymentMethod.value
        }`,
        { params: { booking: selectedBooking.value } }
      );
      switch (refundPaymentMethod.value) {
        case PaymentMethodTypes.CardAuto:
          proceedAdyenRefund(amountInCents);
          break;

        default:
          proceedRegularRefund(amountInCents);
          break;
      }
    }

    const isPromocodeApplied = computed(() => {
      return BookingModule.isPromocodeApplied;
    });

    const showDiscountButton = computed(() => {
      // Hide discount button for Chillon (L2-1009)
      if (POSConfigModule.groupId === 16268) {
        return false;
      }
      return true;
    });

    const refundAmount = computed(() => {
      /**
       * If refund payment is card, return only refundable adyen payments amount
       * Otherwise, return the full amount to refund
       */

      return refundPaymentMethod.value === PaymentMethodTypes.CardAuto
        ? cardRefundAmount.value
        : restToPay.value;
    });

    const cardRefundAmount = computed(() => {
      let amountToRefund = 0;

      const accountings = selectedBooking.value.accountings;
      const isValidAdyenPayment = (
        acc: IAccounting,
        uuid: string | null,
        isRefund = false
      ) =>
        adyenPaymentMethods.includes(acc.paymentMethod) &&
        (isRefund
          ? acc.transactionType === TransactionTypes.TRANSACTION_TYPE_REFUND
          : acc.transactionType ===
            TransactionTypes.TRANSACTION_TYPE_PAYMENT) &&
        acc.state === AccountingState.Completed &&
        (isRefund ? acc.refundPspReference : acc.pspReference) &&
        acc.accountingEntriesList.some(
          (ae) => ae.productSlotStateUuid === uuid
        );

      for (const pssToRefund of pssToRefundList.value) {
        const uuid = pssToRefund.uuid;

        const paymentAmounts = accountings
          .filter((acc) => isValidAdyenPayment(acc, uuid))
          .flatMap((acc) =>
            acc.accountingEntriesList
              .filter((ae) => ae.productSlotStateUuid === uuid)
              .map((ae) => ae.value)
          );

        const refundAmounts = accountings
          .filter((acc) => isValidAdyenPayment(acc, uuid, true))
          .flatMap((acc) =>
            acc.accountingEntriesList
              .filter((ae) => ae.productSlotStateUuid === uuid)
              .map((ae) => ae.value)
          );

        amountToRefund += sumArray(paymentAmounts) + sumArray(refundAmounts); // sum because refundAmounts are negative
      }

      return Math.min(amountToRefund * -1, 0);
    });

    const refundAmountText = computed(() => {
      return (
        formatCurrency(paymentCurrency.value) +
        " " +
        (refundAmount.value / 100).toFixed(2)
      );
    });

    function isRefundPaymentMethodDisabled(paymentSetting: any) {
      if (
        paymentSetting.id === PaymentMethodTypes.CardAuto &&
        (!POSConfigModule.selectedConfig?.isRefundActivated ||
          cardRefundAmount.value * -1 <= 0 ||
          cardRefundAmount.value !== restToPay.value)
      ) {
        /**
         * Card refunds are disabled in case:
         * 1- It is disabled from BO
         * 2- There's no refundable card amount
         * 3- Card refund amount !== the total refund amount, meaning in case of split payments (cash & card), until it is requested by the client.
         */

        return true;
      }
      return false;
    }

    // Whenever the user resets paymentSettings we need to select a default paymentMethod
    watch(
      paymentSettings,
      () => {
        selectdefaultPaymentMethod();
      },
      { deep: true }
    );

    watch([step, paymentTool], () => {
      if (!payInMultiCurrencies.value) {
        return;
      }

      if (
        BookingModule.selectedBookingPaymentMethodId !==
          PaymentMethodTypes.Cash ||
        step.value !== BookingStep.Payment
      ) {
        // toggle off multi currency if not using cash or not in payment step
        toggleMultiCurrencies();
      }
    });

    return {
      t,
      paymentTool,
      paymentCard,
      hasEnteredAmount,
      isFullDiscount,
      whatIsLeftToPay,
      displayedAmount,
      // total,
      formattedPaymentCurrency,
      // bookingTotal,
      PaymentTool,
      PaymentCard,
      showDiscount,
      paymentCurrency,
      // showCashButton,
      step,
      BookingStep,
      updatePaymentCurrency,
      updateEnteredAmount,
      updatePaymentTool,
      updatePaymentCard,
      applyCashPayment,
      showCalculator,
      disablePaymentTool,
      Currencies,
      displayDiscounts,
      displayPromocodeArea,
      iconContent,
      iconAlt,
      iconStyle,
      cashPaymentMethod,
      cardAutoPaymentMethod,
      cardManualPaymentMethod,
      bankTransferPaymentMethod,
      InvoicePaymentMethod,
      isFree1,
      isFullyPaidInPromocodeStep,
      isFullyPaidInDiscountStep,
      canCompleteOrder,
      selectedBooking,
      groupId,
      getLocale,
      doesSupportSplitPayment,
      whatIsLeftToPayText,
      isEditOrder,
      ChequePaymentMethod,
      ChequeVacancesPaymentMethod,
      handleRefund,
      paymentSettings,
      PaymentMethodTypeToPaymentTool,
      PaymentMethodTypeToTranslatedString,
      CEPaymentMethod,
      OCCYGPaymentMethod,
      selectdefaultPaymentMethod,
      refundPaymentMethod,
      refundPaymentMethodOptions,
      PaymentMethodTypes,
      isPromocodeApplied,
      currencies,
      selectedCashCurrency,
      groupCurrency,
      selectedCashCurrencyChanged,
      selectedCashCurrencyLabel,
      toggleMultiCurrencies,
      payInMultiCurrencies,
      bookingPaymentCurrency,
      restToPay,
      hasMultiCurrenciesEnabled,
      showDiscountButton,
      displayPromocodeCampaigns,
      displayOffers,
      isRefundPaymentMethodDisabled,
      refundAmount,
      refundAmountText,
      promocodeBeingChecked,
    };
  },
  async created() {
    // check availabilities before completing the booking
    await syncBookingAvailabilities(this.selectedBooking);
  },
  async mounted() {
    this.selectdefaultPaymentMethod();

    const leftToPay = restToPay.value;
    updateEnteredAmount(Math.abs(leftToPay) / 100);
  },
  beforeUnmount() {
    BookingModule.setSelectedCashCurrency(null);
    updateEnteredAmount(0);
  },
});
</script>

<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;

.complete-order-wrapper {
  height: 100%;
  padding-bottom: 10px;

  .selected {
    border: none;
    border-bottom: 8px solid $color-dark-cyan;
    background-color: color-mix(
      in srgb,
      var(--primary-smeetz) 65%,
      transparent
    );
  }

  .selected-warning {
    border: none;
    border-bottom: 8px solid $color-danger-red;
    background-color: rgba($color: $color-danger-red, $alpha: 0.65);
  }

  .disabled-payment-option {
    opacity: 0.3;
    cursor: not-allowed;
  }

  .payment-option {
    height: 50px;
    font-size: 16px;
    font-weight: 700;
    transition-duration: 0.5s;
    white-space: pre-wrap;
  }

  .payment-option:not(.disabled-payment-option, .selected-warning):hover {
    transition-duration: 0.5s;
    border: none;
    border-bottom: 8px solid $color-dark-cyan;
    background-color: color-mix(
      in srgb,
      var(--primary-smeetz) 65%,
      transparent
    );
  }

  .currency-button {
    padding: 25px 45px;
    margin: 3px 1px;
    border: none;
    background-color: $color-light-grey3;
    color: $color-text-primary;
    max-width: 120px;
  }

  .amount-button {
    margin: 1px 1px;
    border: none;
    background-color: $color-pacific-blue;
    font-weight: bold;
    color: $background-color-base;
    width: 120px;
    height: 50px;
  }

  .back-button {
    background-color: $color-grey1;
    // font-weight: bold;
    color: white;
  }

  .active {
    background-color: $color-pacific-blue;
    font-weight: bold;
    color: $background-color-base;
  }

  .order-amount {
    background-color: $color-light-grey3;
    color: $color-text-primary;
    padding: 30px 19%;
    margin: 3vh 0;
    border-radius: 4px;
    border: none;
    font-size: 16px;
  }

  .default-cursor {
    cursor: default;
  }

  .complete-button {
    background-color: $color-dark-cyan;
    color: $background-color-base;
    font-weight: bold;
    margin-top: 1vh;
    width: 98%;
    height: 50px;
  }

  .apply-button {
    margin-top: 3vh;
    width: 366px;
    height: 50px;
  }

  .complete-button-bg {
    background: $color-light-grey4;
  }

  p {
    font-weight: bold;
    text-align: center;
    margin-top: 20vh;
  }
  .apply-btn {
    margin-top: 50px;
    background-color: $color-swamp-green;
    color: $background-color-clear;
  }
  .light-text {
    margin: 0;
    color: rgba(0, 0, 0, 0.5);
    font-family: Helvetica;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}
</style>
